import React, { Component } from 'react';
import {
	Panel,
	Button,
	Checkbox,
	FormControl,
	Row,
	Col,
	Label,
	OverlayTrigger,
	Tooltip,
	FormGroup,
	Radio,
} from 'react-bootstrap';
import UiUtils from '../../utils/UiUtils';
import ApiClient from '../../utils/ApiClient';
import Session from '../../utils/Session';
import TablePlain from '../../components/table-plain/TablePlain';
import QuestionDialog from '../../components/question-dialog/QuestionDialog';
import UserDialog from './components/user-dialog/UserDialog';
import ChangePasswordDialog from './components/change-password-dialog/ChangePasswordDialog';
import TableUsers from './components/table-users/TableUsers';
import './Perfil.css'
import lstrings from '../../utils/LStrings';

class Perfil extends Component {

	constructor(props) {
		super(props);

		this.state = {
			userDialog: {
				showing: false,
				user: null
			},
			deleteDialog: {
				showing: false,
				message: '',
				user: {}
			},
			showingChangePasswordDialog: false,
			cliente: {
				idCliente: 0,
				cliente: "",
				nombre: "",
				apellido: "",
				email: "",
				cuil: 0,
			},
			user: {
				isUsing2FA: false,
			},
			totpHabilitado: false, // por defecto no muestro la sección TOTP
			listUsers: [],
			asociadosSelectedFile: undefined,
			asociadosNameFile: lstrings.no_file,
			asociadosAccion: undefined,
			counter: 0,
		}
	}

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		UiUtils.showProgress(true);

		ApiClient
			.getCurrentUser()
			.then(this.onFinishGetCurrentUser);

		ApiClient
			.getAccount()
			.then(this.onFinishGetClienteAccount)
			.then(() => {
				UiUtils.showProgress(true);
				return ApiClient.getListUsers();
			})
			.then(this.onFinishGetListUsers)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});
	}

	onFinishGetCurrentUser = (res) => {
		UiUtils.showProgress(false);
		if (res.result.code === 200) {
			this.setState({
				...this.state,
				user: res.data,
				totpHabilitado: res.data.isUsing2FA
			});
		} else {
			throw UiUtils.handledError(res.result.info);
		}
	}

	onFinishGetClienteAccount = (res) => {
		UiUtils.showProgress(false);
		if (res.result.code === 200) {
			this.setState({
				cliente: res.data,
				totpHabilitado: res.data.isUsing2FA
			});
		} else {
			throw UiUtils.handledError(res.result.info);
		}
	}

	onFinishGetListUsers = (res) => {
		UiUtils.showProgress(false);
		if (res.result.code === 200) {
			this.setState({ listUsers: res.data.users });
		} else {
			throw UiUtils.handledError(res.result.info);
		}
	}

	onModifyUser = (user) => {
		this.setState({
			userDialog: {
				showing: true,
				user: user
			}
		});
	}

	onCloseUserDialog = () => {
		this.setState({
			userDialog: {
				showing: false,
				user: null
			}
		});
	}

	onCreateUser = (newUser) => {
		newUser.cliente = {
			id: this.state.cliente.idCliente
		};
		UiUtils.showProgress(true);
		ApiClient
			.createUser(newUser)
			.then(this.onFinishUpdateUser)
			.catch((error) => {
				error
					.response
					.then((e) => {
						UiUtils.showProgress(false);
						UiUtils.showAlert('Error', e.message);
					})

			});
	}

	onModifiedUser = (user) => {
		UiUtils.showProgress(true);
		ApiClient
			.modifyUser(user)
			.then(this.onFinishUpdateUser)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});
	}

	onFinishUpdateUser = (res) => {
		UiUtils.showProgress(false);
		if (res.result.code === 200) {
			if (res.data) {
				this.onCloseUserDialog();
				this.getData();
			} else {
				throw UiUtils.handledError("Ocurrió un error al actualizar los datos del usuario");
			}
		} else {
			throw UiUtils.handledError(res.result.info);
		}
	}

	onDeleteUser = (user) => {
		this.setState({
			deleteDialog: {
				showing: true,
				message: `¿Desea eliminar al usuario ${user.usuario}?`,
				user: user
			}
		});
	}

	onAcceptDelete = () => {
		UiUtils.showProgress(true);
		ApiClient
			.deleteUser(this.state.deleteDialog.user)
			.then(this.onFinishDeleteUser)
			.catch((error) => {
				UiUtils.showProgress(false);
				UiUtils.showError(error);
			});

		this.onCloseDeleteDialog();
	}

	onFinishDeleteUser = (res) => {
		UiUtils.showProgress(false);
		if (res.result.code === 200) {
			this.onCloseDeleteDialog();
			this.getData();
		} else {
			throw UiUtils.handledError("Ocurrió un error al elminar el usuario");
		}
	}

	onCloseDeleteDialog = () => {
		this.setState({
			deleteDialog: {
				showing: false,
				message: '',
				user: null
			}
		});
	}

	onChangePasswordClick = () => {
		this.setState({ showingChangePasswordDialog: true });
	}
	onCloseChangePasswordDialog = () => {
		this.setState({ showingChangePasswordDialog: false });
	}
	onChangePassword = (newPass, oldPassword, twoFactorCode) => {

		ApiClient
			.changePassword(newPass, oldPassword, twoFactorCode)
			.then(this.onFinishChangePassword)
			.catch((error) => {

				UiUtils.showError(error)
			});

	}


	/**
	 * Two Factor Authentication 2FA
	 * 
	 * @param {Object} changeEvent 
	 */
	on2FACheckboxChange = (changeEvent) => {
		this.setState({
			user: {
				...this.state.user,
				isUsing2FA: changeEvent.target.checked
			}
		});

		if (!this.state.user.isUsing2FA) {
			if (this.state.totpHabilitado) {
				// Deshahilitar 2FA
				console.log("tengo que desactivar")
			} else {
				// Habilitar 2FA
				ApiClient
					.getTotpSecret(this.state.user.username)
					.then((data) => {
						this.setState({
							...this.state,
							totpSecret: data.secret,
							totpQr: data.qrData
						})
					});
			}
		}
	}

	mostrarValidarTotp = () => {
		return this.state.user ?
			(this.state.user.isUsing2FA && !this.state.totpHabilitado)
			|| (!this.state.user.isUsing2FA && this.state.totpHabilitado)
			: false

	}

	mostrarQr = () => {
		return this.state.user ?
			this.state.user.isUsing2FA && !this.state.totpHabilitado :
			false
	}

	resetTotpInput = () => {
		this.setState({
			...this.state,
			totpClave: undefined,
			totpSecret: undefined,
			totpQr: undefined
		})
	}

	configure2FA = () => {
		if (this.mostrarQr()) {
			// Habilito 2FA
			ApiClient
				.enableTotp(
					this.state.user.username,
					this.state.totpClave,
					this.state.totpSecret)
				.then((response) => {
					if (response.status === 200) {
						this.state.totpHabilitado = response.data.totpValido
					}

					if (this.state.totpHabilitado) {
						this.resetTotpInput()
						UiUtils.showAlert(
							"Configuración 2FA",
							"Se activó la Verificación en Dos Pasos para el usuario"
						);
					}
					else {
						UiUtils.showAlert(
							"Configuración 2FA",
							"No se pudo verificar el código ingresado"
						);
					}
				});
		}
		else {
			// Desactivo 2FA
			ApiClient
				.disableTotp(
					this.state.user.username,
					this.state.totpClave)
				.then((response) => {
					console.log("rta", response.status)

					if (response.status === 200) {
						this.setState({
							...this.state,
							totpHabilitado: !response.data.totpValido,
						})
					}

					if (this.state.totpHabilitado) {
						UiUtils.showAlert(
							"Configuración 2FA",
							"No se pudo verificar el código ingresado"
						);
					}
					else {
						this.resetTotpInput()
						UiUtils.showAlert(
							"Configuración 2FA",
							"Se eliminó la Verificación en Dos Pasos para el usuario"
						);
					}
				});
		}
	}

	handleChangeCode = (event) => {
		this.setState({
			...this.state,
			totpClave: event.target.value
		});
	}
	handleEnterPress = (ev) => {
		if (ev.key === 'Enter') {
			this.onSubmitTwoFactorConfig();
		}
	}

	onSubmitTwoFactorConfig = () => {
		if (this.state.totpClave.length !== 6) {
			UiUtils.showAlert("Atención", "Verfique el código ingresado");
			return;
		}

		this.configure2FA();
	}

	onFinishChangePassword = (res) => {
		if (res.status != null && res.status > 300) {
			UiUtils.showAlert("Error", res.message)
		}
		else {
			if (res.result.code === 200) {
				if (res.data) {
					this.onCloseChangePasswordDialog();
					UiUtils.showAlert("Información", "Se ha cambiado su contraseña con éxito");
				} else {
					throw UiUtils.handledError("Ocurrió un error al cambiar la contraseña");
				}
			} else {
				throw UiUtils.handledError(res.result.info);
			}

		}
	}

	/**
	 * Almaceno el archivo seleccionado y guardo el nombre
	 */
	fileProcesar = (event) => {
		this.setState({
			asociadosNameFile: event.target.files[0].name,
			asociadosSelectedFile: event.target.files[0],
		});
	}

	/**
	 * Almaceno la acción para tratar los datos del archivo
	 */
	fileAccion = (event) => {
		if (event.target.value != undefined) {
			this.setState({
				asociadosAccion: event.target.value,
			});
		}
	}

	/**
	 * 
	 */
	onSendClickProcesar = () => {
		UiUtils.showProgress(true);

		if (this.state.asociadosSelectedFile != undefined
			&& this.state.asociadosAccion != undefined) {
			ApiClient.solicitudActualizacionAsociados(
				this.state.asociadosSelectedFile,
				this.state.asociadosAccion
			).then((res) => {
				if (res.result.code === 200) {
					this.setState({
						asociadosNameFile: lstrings.no_file,
						asociadosSelectedFile: undefined,
						asociadosAccion: undefined,
					});

					UiUtils.showAlert("Enviado", "¡Se envió el archivo correctamente!");
					UiUtils.showProgress(false);
				}
			}).catch((error) => {
				// Blanqueo el estado del componente
				this.setState({
					asociadosNameFile: lstrings.no_file,
					asociadosSelectedFile: undefined,
					asociadosAccion: undefined,
				});

				UiUtils.showError(error);
				UiUtils.showProgress(false);
			});
		} else {
			UiUtils.showAlert("Aviso", "Debe seleccionar un archivo y una acción");
			UiUtils.showProgress(false);
		}
	}

	render() {

		const titulo = <h4>
			<i className="fa fa-user"></i>Mi Cuenta</h4>;
		const tituloSeguridad = <h4>
			<i className="fa fa-shield"></i>Seguridad</h4>;
		const tituloUsuarios = <h4>
			<i className="fa fa-users"></i>Usuarios</h4>;
		const tituloAsociados = <h4>
			<i className="fa fa-users"></i>Actualización Asociados</h4>;

		return (
			<div>
				<UserDialog
					show={this.state.userDialog.showing}
					user={this.state.userDialog.user}
					onClose={this.onCloseUserDialog}
					onCreateUser={this.onCreateUser}
					onModifiedUser={this.onModifiedUser} />
				<ChangePasswordDialog
					show={this.state.showingChangePasswordDialog}
					onClose={this.onCloseChangePasswordDialog}
					onChangePassword={this.onChangePassword}
					checked={this.state.user.isUsing2FA} />
				<QuestionDialog
					show={this.state.deleteDialog.showing}
					title="Atención"
					message={this.state.deleteDialog.message}
					onAccept={this.onAcceptDelete}
					onCancel={this.onCloseDeleteDialog} />
				<h1>Panel de control</h1>

				<Panel defaultExpanded header={titulo}>
					<TablePlain
						title=""
						columns={[
							'ID Cliente',
							'Cliente',
							'Nombre',
							'Apellido',
							'Email',
							'CUIL/CUIT'
						]}
						rows={[
							<tr key={1}>
								<td>{this.state.cliente.idCliente}</td>
								<td>{this.state.cliente.cliente}</td>
								<td>{this.state.cliente.nombre}</td>
								<td>{this.state.cliente.apellido}</td>
								<td>{this.state.cliente.email}</td>
								<td>{this.state.cliente.cuil}</td>
							</tr>
						]} />
					<Row>
						<Col xs={2} xsOffset={10}>
							<Button
								bsStyle="primary"
								className="btn-block"
								onClick={this.onChangePasswordClick}>Cambiar contraseña</Button>
						</Col>
					</Row>
				</Panel>

				<Panel defaultExpanded header={tituloSeguridad}>
					<Row>
						<Col xs={4} xsOffset={4}>
							<Checkbox
								id="totpCheckbox"
								className="text-center"
								checked={this.state.user.isUsing2FA == true}
								onChange={this.on2FACheckboxChange}>
								Verificación en dos pasos
							</Checkbox>
						</Col>
					</Row>

					{this.mostrarValidarTotp() && <div>
						{this.mostrarQr() &&
							<Row>
								<Col xs={2} xsOffset={5}>
									<div className="text-center">
										<img name="totpQr" src={this.state.totpQr} width="200" height="200" />
									</div>
								</Col>
							</Row>
						}
						<Row>
							<Col xs={2} xsOffset={5}>
								<Label bsStyle="info" className="text-center">
									Ingrese el código de 6 dígitos
								</Label>
								<FormControl
									type="number"
									placeholder="Código"
									onChange={this.handleChangeCode}
									onKeyPress={this.handleEnterPress} />
							</Col>
						</Row>
						<Row>
							<Col xs={2} xsOffset={5}>
								<Button
									bsStyle="primary"
									className="btn-block"
									onClick={this.onSubmitTwoFactorConfig}>
									{this.mostrarQr() ? "Verificar" : "Desactivar 2FA"}
								</Button>
							</Col>
						</Row>
					</div>
					}
				</Panel>

				{Session
					.getUser()
					.isDisa && <Panel defaultExpanded header={tituloAsociados}>
						<Row>
							<Col sm={2} smPush={10} md={2} mdPush={8} lg={1} lgPush={8}>
								<form>
									<FormGroup>
										<Radio name="asociadosAccionRadioGroup"
											value="alta"
											onChange={(event) => this.fileAccion(event)}
											checked={this.state.asociadosAccion === "alta"}
										>
											Alta
										</Radio>
										<Radio name="asociadosAccionRadioGroup"
											value="desafectaciones"
											onChange={(event) => this.fileAccion(event)}
											checked={this.state.asociadosAccion === "desafectaciones"}
										>
											Desafectaciones
										</Radio>
									</FormGroup>
								</form>
							</Col>
						</Row>
						<Row>
							<Col sm={10} md={6} mdPush={2} lg={4} lgPush={3}>
								<OverlayTrigger placement="bottom" overlay={
									<Tooltip id="tooltip">
										Se aceptan archivos de texto plano, documentos y planillas de cálculo
									</Tooltip>
								}>
									<label className="btn-file">
										Seleccionar archivo
										<input
											type="file"
											accept=".txt,.csv,.xls,.xlsx,.doc,.docx,.ods,.odt"
											id="myFile"
											className="input-file"
											style={{
												display: 'none'
											}}
											onChange={(event) => this.fileProcesar(event)} />
									</label>
								</OverlayTrigger>
								{this.state.asociadosNameFile}
							</Col>

							<Col sm={2} md={2} mdPush={2} lg={1} lgPush={4}>
								<Button
									style={{
										fontSize: '10px'
									}}
									bsStyle="primary"
									className="btn-block btn-archivo"
									onClick={this.onSendClickProcesar}
								>
									Enviar
								</Button>
							</Col>
						</Row>
					</Panel>
				}

				{Session
					.getUser()
					.isAdmin && <Panel defaultExpanded header={tituloUsuarios}>
						<TableUsers
							data={this.state.listUsers}
							onDeleteUser={this.onDeleteUser}
							onModifyUser={this.onModifyUser} />
					</Panel>
				}
			</div>
		);
	}
}

export default Perfil;



// WEBPACK FOOTER //
// ./src/scenes/me/Perfil.js